export const useHostPath = (path?: string) =>
  window.location.protocol +
  "//" +
  window.location.host +
  "/" +
  (path ? path : "");
